module.exports = __webpack_public_path__ + "img/money.8e40c717.png";